import axios from "axios";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import BlogList from "./views/BlogList";
import BlogView from "./views/BlogView";
import Events from "./views/Events";
import Layout from "./views/layout";
import Page404 from "./views/Page404";
import Refrences from "./views/Refrences";

function App() {
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const { status, data } = await axios.get(
        "https://irfanwrites.herokuapp.com/posts"
      );
      if (status === 200) {
        setData(data);
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (!loading) {
    return (
      <BrowserRouter>
        <Layout>
          <Switch>
            <Route path='/' exact>
              <BlogList blogs={Data} />
            </Route>
            <Route path='/Events' exact>
              <Events></Events>
            </Route>
            <Route path='/posts/:id' exact component={BlogView}></Route>
            <Route pah='/ref/:platform' exact component={Refrences}></Route>
            <Route path='/:id' component={Page404}></Route>
          </Switch>
        </Layout>
      </BrowserRouter>
    );
  } else {
    return (
      <div class='d-flex mt-5 pt-5 justify-content-center'>
        <div class='spinner-grow' role='status'>
          <span class='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }
}

export default App;
